import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss'],
})
export class AlertBoxComponent implements OnInit {
  buttonName: string = '';
  text: string = '';
  buttonAction: Function;

  constructor(
    public dialogRef: MatDialogRef<AlertBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.buttonAction = data.buttonAction;
    this.buttonName = data.buttonName;
    this.text = data.text;
  }

  ngOnInit(): void {}
}
